module.exports = __webpack_public_path__ + "img/layout-split.83137088.svg";